module.exports = __webpack_public_path__ + "img/bread.sydney.30b3c189.svg";